{
  "version": 1,
  "asset_id": "71f6a566-7b5a-4d22-89b0-e4d891280411",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/71f6a566-7b5a-4d22-89b0-e4d891280411/sleeve-dissection-revision-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/71f6a566-7b5a-4d22-89b0-e4d891280411/sleeve-dissection-revision-800.webp",
  "original_filename": "sleeve-dissection-revision-800.webp",
  "size": 40210,
  "content_type": "image/webp",
  "created_at": "2026-10-05T12:43:10Z"
}
